export default {
    _prefix: "qualityFormEditor.common.error",
    labels: {
        formValidationErrors: "Form Validation Errors",
        cancel: "Cancel",
        visibilityConditionErrorMessage: {
            delete: (data: {
                referredEntityType: string;
                referredSequenceNumber?: string;
                dependentEntityType: string;
                dependentSequenceNumber: string;
            }) => {
                return "This {{referredEntityType}} cannot be deleted because {{dependentEntityType}} {{dependentSequenceNumber}} depends on it.";
            },
            moveUp: (data: {
                referredEntityType: string;
                referredSequenceNumber: string;
                dependentEntityType: string;
                dependentSequenceNumber: string;
            }) => {
                return "{{referredEntityType}} {{referredSequenceNumber}} cannot be moved up because it has visibility conditions that depend on {{dependentEntityType}} {{dependentSequenceNumber}}.";
            },
            moveDown: (data: {
                referredEntityType: string;
                referredSequenceNumber: string;
                dependentEntityType: string;
                dependentSequenceNumber: string;
            }) => {
                return "{{referredEntityType}} {{referredSequenceNumber}} cannot be moved down because {{dependentEntityType}} {{dependentSequenceNumber}} has visibility conditions that depend on it.";
            },
        },
        visibilityConditionErrorMessageForQuestionGroup: {
            moveUp: (data: {
                referredEntityType: string;
                referredSequenceNumber: string;
                dependentSequenceNumber: string;
                conditionalEntitySequenceNumber: string;
            }) => {
                return "Question group {{referredSequenceNumber}} cannot be moved up because question {{dependentSequenceNumber}} has visibility conditions that depend on question {{conditionalEntitySequenceNumber}}.";
            },
            moveDown: (data: {
                referredEntityType: string;
                referredSequenceNumber: string;
                dependentSequenceNumber: string;
                conditionalEntitySequenceNumber: string;
            }) => {
                return "Question group {{referredSequenceNumber}} cannot be moved down because question {{dependentSequenceNumber}} has visibility conditions that depend on question {{conditionalEntitySequenceNumber}}.";
            },
        },
        entityType: {
            questionGroup: "question group",
            question: "question",
            answer: "answer",
            move: {
                questionGroup: "Question group",
                question: "Question",
                answer: "Answer",
            },
            delete: {
                questionGroup: "question group",
                question: "question",
                answer: "answer",
            },
        },
        errorAction: {
            moveUp: "moved up",
            moveDown: "moved down",
            delete: "deleted",
        },
    },
};
